import React from 'react'
import { useNavigate } from 'react-router-dom'

const NotFoundPage: React.FC = () => {
  const navigate = useNavigate()

  const styles = {
    container: {
      display: 'flex',
      flexDirection: 'column' as const,
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      backgroundColor: '#f8fafc',
      padding: '2rem'
    },
    content: {
      textAlign: 'center' as const,
      maxWidth: '500px'
    },
    errorCode: {
      fontSize: '6rem',
      fontWeight: 'bold',
      color: '#dc2626',
      margin: '0',
      lineHeight: '1'
    },
    title: {
      fontSize: '2rem',
      fontWeight: '600',
      color: '#1f2937',
      margin: '1rem 0'
    },
    description: {
      fontSize: '1.125rem',
      color: '#6b7280',
      margin: '1rem 0 2rem 0',
      lineHeight: '1.6'
    },
    button: {
      backgroundColor: '#2563eb',
      color: 'white',
      padding: '0.75rem 1.5rem',
      border: 'none',
      borderRadius: '0.375rem',
      fontSize: '1rem',
      fontWeight: '500',
      cursor: 'pointer',
      transition: 'background-color 0.2s',
      marginRight: '1rem'
    },
    secondaryButton: {
      backgroundColor: 'transparent',
      color: '#2563eb',
      padding: '0.75rem 1.5rem',
      border: '2px solid #2563eb',
      borderRadius: '0.375rem',
      fontSize: '1rem',
      fontWeight: '500',
      cursor: 'pointer',
      transition: 'all 0.2s'
    }
  }

  return (
    <div style={styles.container}>
      <div style={styles.content}>
        <h1 style={styles.errorCode}>404</h1>
        <h2 style={styles.title}>ページが見つかりません</h2>
        <p style={styles.description}>
          お探しのページは存在しないか、移動または削除された可能性があります。
          <br />
          URLをご確認いただくか、ホームページからお探しください。
        </p>
        <div>
          <button
            style={styles.button}
            onClick={() => navigate('/')}
            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#1d4ed8'}
            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#2563eb'}
          >
            ホームページに戻る
          </button>
          <button
            style={styles.secondaryButton}
            onClick={() => navigate(-1)}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = '#2563eb'
              e.currentTarget.style.color = 'white'
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = 'transparent'
              e.currentTarget.style.color = '#2563eb'
            }}
          >
            前のページに戻る
          </button>
        </div>
      </div>
    </div>
  )
}

export default NotFoundPage